// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import chevronRightIcon from "@/assets/icons/chevron-right.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ChevronRightIconProps = Omit<IconProps, "name">;

export function ChevronRightIcon(props: ChevronRightIconProps): React.ReactNode {
  return <Icon name={chevronRightIcon} {...props} />;
}
